const state = {
    alarmHistoryDataFields: [
        {
            key: "alarmCode",
            label: "警報代碼",
            sortable: true,
        },
        {
            key: "alarmDetail",
            label: "警報代碼說明",
            sortable: true,
        },
        {
            key: "alarmVideo",
            label: "機台影像",
            sortable: true,
        },
        {
            key: "startTime",
            label: "開始時間",
            sortable: true,
        },
        {
            key: "endTime",
            label: "結束時間",
            sortable: true,
        },
        {
            key: "continuousTime",
            label: "持續時間",
            sortable: true,
        }
    ],
    alarmHistoryDataItem: [],
    deviceName: '',
    alarmHistoryTableStyle: '',
}
const getters = {
    get_alarmHistoryDataFields: state => {
        return state.alarmHistoryDataFields
    },
    get_alarmHistoryDataItem: state => {
        return state.alarmHistoryDataItem
    },
    get_deviceName: state => {
        return state.deviceName
    },
    get_alarmHistoryTableStyle: state => {
        return state.alarmHistoryTableStyle
    },
}
const actions = {
    set_alarmHistoryDataFields(context, array) {
        context.commit('SET_ALARMHISTORYDATAFIELDS', array);
    },
    set_alarmHistoryDataItem(context, array) {
        context.commit('SET_ALARMHISTORYDATAITEM', array);
    },
    clear_alarmHistoryDataItem(context) {
        context.commit('CLEAR_ALARMHISTORYDATAITEM');
    },
    set_deviceName(context, string) {
        context.commit('SET_DEVICENAME', string);
    },
    set_alarmHistoryTableStyle(context, string = '') {
        context.commit('SET_ALARMHISTORYTABLESTYLE', string);
    },
}
const mutations = {
    SET_ALARMHISTORYDATAFIELDS(state, array) {
        state.alarmHistoryDataFields = array;
    },
    SET_ALARMHISTORYDATAITEM(state, array) {
        state.alarmHistoryDataItem = array;
    },
    CLEAR_ALARMHISTORYDATAITEM(state) {
        state.alarmHistoryDataItem = [];
    },
    SET_DEVICENAME(state, string) {
        state.deviceName = string;
    },
    SET_ALARMHISTORYTABLESTYLE(state, string) {
        state.alarmHistoryTableStyle = string;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alarmHistoryData.js